import actions from '../actions/progressPayment';

export const getProgressPaymentTemplates = async (queryString) => {
  return actions.getProgressPaymentTemplates(queryString);
};

export const deleteProgressPaymentTemplates = async (id, payload) => {
  return actions.deleteProgressPaymentTemplates(id, payload);
};

export const addProgressPaymentTemplates = async (payload, type) => {
  return actions.addProgressPaymentTemplates(payload, type);
};

export const editProgressPaymentTemplates = async (payload, id, type) => {
  return actions.editProgressPaymentTemplates(payload, id, type);
};

export const getClosedDates = async (queryString) => {
  return actions.getClosedDates(queryString);
};

export const deleteClosedDates = async (id) => {
  return actions.deleteClosedDates(id);
};

export const addClosedDate = async (payload) => {
  return actions.addClosedDate(payload);
};

export const getProgressPaymentData = async (queryString) => {
  return actions.getProgressPaymentData(queryString);
};

export const getProgressPaymentDetail = async (queryString) => {
  return actions.getProgressPaymentDetail(queryString);
};

export const getProgressPaymentOrderDetail = async (queryString) => {
  return actions.getProgressPaymentOrderDetail(queryString);
};

export const exportProgressPaymentStatusReport = async (payload) => {
  return actions.exportProgressPaymentStatusReport(payload);
};

export const refreshProgressPayment = async () => {
  return actions.refreshProgressPayment();
};

export const getStoreProgressPaymentStatus = async (queryString) => {
  return actions.getStoreProgressPaymentStatus(queryString);
};
export const getStoreProgressPaymentDetail = async (id) => {
  return actions.getStoreProgressPaymentDetail(id);
};
export const getCourierDeliveryEfficiencyOtifMonthly = async (payload) => {
  return actions.getCourierDeliveryEfficiencyOtifMonthly(payload);
};
export const getCourierDeliveryEfficiencyOtifDaily = async (payload) => {
  return actions.getCourierDeliveryEfficiencyOtifDaily(payload);
};
export const exportStoreProgressPaymentStatusReport = async (payload) => {
  return actions.exportStoreProgressPaymentStatusReport(payload);
};

export const getProgressPaymentTemplateByStore = async (queryString) => {
  return actions.getProgressPaymentTemplateByStore(queryString);
};

export const approveInvoicePayment = async (payload) => {
  return actions.approveInvoicePayment(payload);
};
